import AgreementsCard from './AgreementsCard';

export default AgreementsCard;
